var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadiant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, "-->\n", /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202 61.8623V190.72L201.235 191.48L173.47 219.233L172.698 220H83.0973L82.3255 219.239L54 191.073V61.7129L82.2572 35.6928L83.0153 35H173.135L202 61.8623ZM88.2405 214.784H167.473L162.609 201.152H92.81L88.2405 214.784ZM180.71 187.623L167.787 200.059L172.37 212.93L195.429 189.884L180.723 187.602L180.71 187.623ZM60.5708 190.224L83.3432 212.875L87.3731 200.86L86.8676 200.317L75.2151 187.758L60.5708 190.224ZM106.211 195.936H148.71L127.809 189.314L106.211 195.936ZM81.3897 186.712L89.2651 195.209L92.7554 184.797L81.3897 186.712ZM165.861 194.659L174.221 186.597L162.329 184.756L165.861 194.659ZM138.97 187.371L160.075 194.055L156.646 184.437L138.97 187.371ZM95.2621 193.83L116.368 187.358L98.4109 184.437L95.2621 193.83ZM59.2457 185.157L74.491 182.59V71.0586L59.2457 67.7849V185.157ZM181.509 71.0586V182.447L196.754 184.811V67.9275L181.509 71.0586ZM99.0393 75.29L93.3906 130.502L99.0052 179.248L127.809 183.935L155.991 179.255L161.626 128.22L155.977 75.3172L126.579 69.3471L99.0393 75.29ZM80.8091 181.523L93.739 179.343L89.552 143.026L80.8091 181.523ZM161.264 179.309L175.082 181.449L165.28 142.897L161.264 179.309ZM166.967 128.227L176.263 164.788V91.5772L166.967 128.227ZM79.7368 162.581L87.7078 127.466L79.7368 93.3227V162.581ZM89.8525 113.576L93.78 75.2017L80.2012 72.288L89.8525 113.576ZM161.243 75.2221L165.314 113.4L175.751 72.2404L161.243 75.2221ZM137.241 66.182L156.715 70.1417L160.861 59.0572L137.241 66.182ZM98.3563 70.101L116.505 66.182L94.5996 59.1183L98.3563 70.101ZM162.5 69.6391L174.761 67.1193L166.564 58.7923L162.5 69.6391ZM81.1028 67.1397L92.6529 69.6187L88.9919 58.9349L81.1028 67.1397ZM168.593 53.3859L180.758 65.7609L180.86 65.8696L195.409 62.8743L172.889 41.9142L168.593 53.3859ZM60.6049 62.7385L75.0853 65.8492L75.2219 65.7133L87.0862 53.3723L83.1793 41.9482L60.6049 62.7385ZM126.593 63.9474L148.553 57.3252H106.034L126.593 63.9474ZM92.2021 52.109H163.47L167.93 40.2162H88.1244L92.2021 52.109Z",
    fill: "#4B4B4B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadiant);
export default __webpack_public_path__ + "static/media/Radiant.c42944bc00fe745b2023c12fa7c35236.svg";
export { ForwardRef as ReactComponent };